module.exports = __webpack_public_path__ + "img/15.0c45ea63.jpg";